
export const ulmsUrl = "https://boardapi.summerhilltechnologies.com/api";

export const holibookUrl = "https://holitest.holisollogistics.com/api";

export const username = "HBOOKAPP";

export const password = "U0VKUFQwdEJVRkF0TWpBeU1qQTJNRGs9";
